import { useEffect, useState } from "react"
import { Input, Button, Table, Space, DatePicker, Select } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const { Column } = Table
const { RangePicker } = DatePicker

type fetchParams = {
    deal_store_id: string[] | undefined
    customer_name: undefined | string
    customer_phone: undefined | string
    date: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        deal_store_id: undefined,
        customer_name: undefined,
        customer_phone: undefined,
        date: null
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.date) {
            params.start_date = params.date[0].format('YYYY-MM-DD')
            params.end_date = params.date[1].format('YYYY-MM-DD')
            delete params.date
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        axiosTable.get('/finance_center/business/promoter_deal/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)

        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 财务中心 -> 经营管理 -> 分销签单管理 */}
        <BreadCrumb position={['财务中心', '分销签单管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores multiple showSearch placeholder="签单门店" value={fetchOtherParams.deal_store_id} onChange={(v: string[]) => { handleChange(v, 'deal_store_id') }} />
                </div>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} value={fetchOtherParams.customer_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_phone') }} value={fetchOtherParams.customer_phone} />
                <RangePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder={["签单开始日期", "签单结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="客户姓名" dataIndex="customer_name" key="customer_name" />
                <Column fixed title="客户手机号" dataIndex="customer_phone" key="customer_phone" />
                <Column fixed title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column fixed title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column title="签单套餐" dataIndex="deal_item_name" key="deal_item_name" />
                <Column title="签单金额" dataIndex="deal_amount" key="deal_amount" />
                <Column title="上级推广员ID" dataIndex="superior_promoter_uid" key="superior_promoter_uid" />
                <Column title="上级推广员昵称" dataIndex="superior_promoter_nickname" key="superior_promoter_nickname" />
                <Column title="上级推广员手机号" dataIndex="superior_promoter_phone" key="superior_promoter_phone" />
                <Column title="顶级推广员ID" dataIndex="top_promoter_uid" key="top_promoter_uid" />
                <Column title="顶级推广员昵称" dataIndex="top_promoter_nickname" key="top_promoter_nickname" />
                <Column title="顶级推广员手机号" dataIndex="top_promoter_phone" key="top_promoter_phone" />
            </Table>
        </div>
    </div >)
}